import Reveal from './Reveal';
import { trustStats } from '@/mocks/home';

export default function TrustStats() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-secondary-200 bg-secondary-100/60">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="border-b border-secondary-200/70 p-6 md:p-8 lg:col-span-4 lg:border-b-0 lg:border-r">
                <span className="font-label text-xs font-medium tracking-[0.25em] text-secondary-700">
                  WHY TRUST
                </span>
                <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950">
                  为什么可以蹲我们
                </h2>
                <p className="mt-3 font-body text-sm leading-relaxed text-foreground-700">
                  每条消息都带着来源代号、核验进度与更新时间。
                  <strong className="font-medium text-foreground-950">待证实</strong>
                  就是待证实，我们不把它写成事实。
                </p>
              </div>

              <div className="grid grid-cols-2 gap-px bg-secondary-200/60 lg:col-span-8 lg:grid-cols-4">
                {trustStats.map((stat) => (
                  <div key={stat.id} className="bg-secondary-50/80 p-6">
                    <span className="font-label text-xs text-foreground-600">{stat.label}</span>
                    <div className="mt-3 flex items-baseline gap-1">
                      <span className="font-heading text-3xl font-bold text-foreground-950">
                        {stat.value}
                      </span>
                      <span className="font-label text-sm text-foreground-500">{stat.unit}</span>
                    </div>
                    <p className="mt-2 font-body text-xs leading-relaxed text-foreground-500">
                      {stat.note}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}